<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('token.history.title-label') }}</h3>
        </div>

        <div v-if="(! isLoaded)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class="container center-items">
            <div v-if="(isLoaded)">
                <div class="container center-items m-0 p-0 mt-4" v-for="tx in transactions" v-bind:key="tx.id">
                    <TokenTransactionItem
                        :tx="tx"
                        :self="self"
                        @onClickCancelButton="cancelTransferButtonHandler"
                    />
                </div>
            </div>

            <!-- ページネーション -->
            <div class="container center-items text-center m-0 p-0 mt-5">
                <paginate v-bind:pagination="pagination" v-on:change-page="fetch(true)"></paginate>
            </div>
        </div>

        <!-- キャンセルモーダル -->
        <vodal :show="showCancelTransferModal" :width="modalWidth" :height="450" :closeButton="false" animation="slideDown" @hide="dismissButtonHandler()">
            <div class="d-flex flex-column p-3 justify-content-end height100">
                <div class="d-flex flex-column">
                    <!-- タイトル -->
                    <div class="d-flex flex-row">
                        <h4 class="text-left text-primary width100">
                            {{ $t('token.cancel.title-label') }}
                        </h4>
                    </div>

                    <div class="d-flex flex-column mt-3">
                        <!-- 説明 -->
                        <p class="m-0 p-0">
                            {{ $t('token.cancel.description-label') }}
                        </p>

                        <!-- 送付情報 -->
                        <ul class="m-0 p-0">
                            <!-- 申請日付 -->
                            <li class="font-weight-bold mt-3">
                                {{ $t('token.cancel.date-label') }}
                            </li>
                            <li><ul><li>
                                {{ cancelContext.created_at | moment('YYYY/MM/DD HH:mm:ss') }}
                            </li>
                            </ul></li>

                            <!-- 数量 -->
                            <li class="font-weight-bold mt-2">
                                {{ $t('token.cancel.volume-label') }}
                            </li>
                            <li><ul><li>
                                {{ cancelContext.amount | round }}
                            </li></ul></li>

                            <!-- 送付先アドレス -->
                            <li class="font-weight-bold mt-2">
                                {{ $t('token.cancel.transfer-to-label') }}
                            </li>
                            <li><ul><li class="text-break">
                                {{ cancelContext.to_address }}
                            </li></ul></li>
                        </ul>

                        <!-- エラー表示 -->
                        <p class="m-0 p-0 mt-2 text-danger" v-if="(errors.id)">
                            {{ $t(`errors.${ errors.id }`) }}
                        </p>
                    </div>
                </div>

                <!-- コントロールボタン -->
                <div class="d-flex flex-row mt-auto">
                    <!-- 閉じる & キャンセルボタン -->
                    <div class="d-flex flex-row justify-content-between width100">
                        <div class="d-flex flex-row mr-auto"></div>
                        <div class="d-flex flex-row">
                            <button type="button" class="btn btn-outline-primary radius-btn modal-dismiss-btn" @click="dismissButtonHandler()">
                                {{ $t('token.cancel.close-label') }}
                            </button>
                            <button type="button" class="btn btn-primary radius-btn modal-cancel-btn ml-2" @click="processCancelTransferButtonHandler(cancelContext.id)">
                                {{ $t('token.cancel.cancel-label') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </vodal>
    </div>
</template>

<script>
    import userService from './../../services/UserService';
    import tokenService from './../../services/TokenService';
    import Paginate from './../../components/Paginate';
    import TokenTransactionItem from './../../components/TokenTransactionItem/TokenTransactionItem';

    export default {
        name: 'TokenHistory',

        components: {
            Paginate,
            TokenTransactionItem,
        },

        data() {
            return {
                self: undefined,
                transactions: [],
                isLoaded: false,
                modalWidth: -1,
                errors: undefined,
                cancelContext: {},
                showCancelTransferModal: false,
                pagination: {
                    total_pages: 0,
                    current_page: 1,
                    per_page: 20,
                    total: 0,
                },
            }
        },

        mounted() {
            this.fetch();
        },

        created() {
            this.initErrors();

            if (window.innerWidth > 992) {
                this.modalWidth = 470;
            }
        },

        methods: {
            initErrors() {
                this.errors = {
                    id: '',
                };
            },

            async fetch(scrollToTop = false) {
                const params = {
                    page: this.pagination.current_page,
                    size: this.pagination.per_page,
                };

                let [ user, txs ] = await Promise.all([
                    userService.getUserFrontendData(),
                    tokenService.getWalletTransactions(params),
                ])

                // 子アカウントの場合はリダイレクト
                if (user.data.is_child) {
                    this.$router.push('/settings');
                    return;
                }

                // 自分のウォレットアドレスを設定
                this.self = (user.data.wallet) ? String(user.data.wallet.address).toLowerCase() : '';

                // トランザクションを設定
                this.transactions = [];
                for (let i in txs.data) {
                    if (txs.data.hasOwnProperty(i) && i !== 'meta') {
                        this.transactions.push(txs.data[i]);
                    }
                }

                // メタデータを設定
                this.isLoaded   = true;
                this.pagination = txs.data.meta.pagination;

                // 場合に応じて (0, 0) にスクロールする
                if (scrollToTop) {
                    window.scrollTo(0, 0);
                }
            },

            async refresh(callback = null) {
                await this.fetch();

                if (callback) {
                    callback();
                }
            },

            dismissButtonHandler(refresh = false) {
                if (refresh) {
                    this.refresh(() => {
                        this.initErrors();
                        this.showCancelTransferModal = false;
                    });
                } else {
                    this.initErrors();
                    this.showCancelTransferModal = false;
                }
            },

            cancelTransferButtonHandler(id) {
                this.cancelContext = this.transactions.find((item) => {
                    return (item.id === id);
                });

                if (this.cancelContext) {
                    this.showCancelTransferModal = true;
                }
            },

            async processCancelTransferButtonHandler(id) {
                try {
                    await tokenService.cancelTransaction({
                        id: id,
                    });

                    // モーダルを非表示
                    this.dismissButtonHandler(true);
                } catch (err) {
                    console.log(err);
                    if (err.response.data.errors) {
                        err.response.data.errors.forEach(errItem => {
                            if (errItem.field) {
                                this.errors[errItem.field] = errItem.message[0];
                            }
                        })
                    }
                }
            },
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";

    .radius-btn {
        border-radius: 0.25rem !important;
    }
    .height100 {
        height: 100%;
    }
    .width100 {
        width: 100%;
    }
    .modal-cancel-btn {
        width: 140px;
    }
    .modal-btn {
        width: 100px;
    }
    .modal-dismiss-btn {
        width: 80px;
    }
    .btn-primary:hover,
    .btn-outline-primary:hover {
        color: #fff !important;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
</style>
